/* File the initializes the redux store and asynchronous calls for state managment
  Functionality:
    - Creates a store from specialized reducers
    - Creates a think for asynchronous API calls */

    import { createStore, applyMiddleware, combineReducers } from 'redux';
    import thunk from 'redux-thunk';
    // TODO: refactor signalR, tired of the error messages when it isn't being used right now
    // import signalrMiddleware from './Middleware/signalrMiddleware';
    import { composeWithDevTools } from 'redux-devtools-extension';
    
    const configureStore = (reducers) => {
        const rootReducer = combineReducers(reducers);
        const middlewareList = [thunk/*, signalrMiddleware*/];
        const middleware = composeWithDevTools(applyMiddleware(...middlewareList));
    
        return createStore(rootReducer, middleware);
    };
    
    export default configureStore;
    